import { render, staticRenderFns } from "./nowupload.vue?vue&type=template&id=3de48488&"
import script from "./nowupload.vue?vue&type=script&lang=js&"
export * from "./nowupload.vue?vue&type=script&lang=js&"
import style0 from "./nowupload.vue?vue&type=style&index=0&id=3de48488&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports